import { useReportWebVitals } from '@/common';
import { HomePageContainer, type HomePageProps } from '@/containers/HomePageContainer';
import { HomepageHead, getHomepageServerSideProps } from '@/components/pages/home';

export const getServerSideProps = getHomepageServerSideProps();

export function Home(props: HomePageProps) {
    const { serverUrl } = props.env;
    const { stage } = props;

    useReportWebVitals();
    return (
        <>
            <HomepageHead serverUrl={serverUrl} stage={stage} />
            <HomePageContainer {...props} />
        </>
    );
}

export default Home;
